<template>
  <div v-if="is_load">
    <div class="container mt-5 pt-2 common_user_container">
<!--      <div class="upper_profile_cover">-->

<!--        <img src="/img/cover_profile.jpg" class="img-fluid">-->

<!--      </div>-->
      <div class="row " >
        <div class="col">
          <div class="text-center">
            <router-link     tag="a"
                :to="{name: 'user_page_main', params: { user_id: user.last_id }}" > <h2>{{ user.name }}</h2></router-link>

          </div>

        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-5 col-sm-5 col-md-3 col-lg-2">
          <v-lazy-image :src="image_url+user.avatar"   alt="" class=" img-thumbnail  img-fluid d-block mx-auto"/>
          <p class="text-center pt-1" v-if="user.rating">Рейтинг: <router-link tag="a" :to="{name:'user_page_reviews',params: { user_id: user.last_id }}"><span class="badge badge-circle badge-info">{{ user.rating}}</span></router-link></p>
          <p class="text-center pt-1" v-if="user.isrewards"> <router-link tag="a" :to="{name:'user_page_rewards',params: { user_id: user.last_id }}">Награды</router-link></p>
        </div>
        <div class="col-7 col-sm-7 col-md-7 col-lg-6" v-if="user.description">

            <div class=" ">
              <p class=" p_preline" v-on:click.stop.prevent="openLinkParagraph" v-html="parsed_text"> </p>
            </div>

        </div>
      </div>

    </div>




    <div class="container mt-5 common_user_container pt-3 pb-3" v-if="user.tabs.length>0">
      <div class="row">
        <div class="col-md-6 col-12 mx-auto d-flex align-items-center justify-content-center">
          <ul class="nav  widget_nav">
            <li class="nav-item" v-if="user.tabs.includes('works')">
              <router-link class="nav-link" :class="{'active':(activeTab=='works')}"   tag="a"
                  :to="{name: 'user_page_portfolio', params: { user_id: user.last_id }}" >Портфолио</router-link>

            </li>
            <li class="nav-item" v-if="user.tabs.includes('services')">
              <router-link class="nav-link" :class="{'active':(activeTab=='services')}"   tag="a"
                  :to="{name: 'user_page_services', params: { user_id: user.last_id }}" >Услуги</router-link>

            </li>
            <li class="nav-item" v-if="user.tabs.includes('items')">
              <router-link class="nav-link" :class="{'active':(activeTab=='items')}"   tag="a"
                  :to="{name: 'user_page_items', params: { user_id: user.last_id }}" >Каталог</router-link>

            </li>

          </ul>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from "vue";
import VLazyImage from "v-lazy-image/v2";

export default {
  name: "CommonUserPage",
  components: {
    VLazyImage
  },
  props: {
    user:Object,
    activeTab:{
        type: String,
        default: ""

    }


  },
  data(){
    return {
      "image_url":"",
      "parsed_text":"",
      "is_load":false,
    }
  },
  methods:{
    openLinkParagraph(e){
      e.preventDefault();
      if(e.target.href){
        this.openLink(e.target.href,e);
      }



    },
    openLink(url,e){
      if(e){
        e.preventDefault();
      }
      var base_url=Vue.config.BASE_URL_FRONT;
      const parse_base_url=new URL(base_url);
      const parse_url = new URL(url);



      if(parse_url.hostname==parse_base_url.hostname){
        this.$router.push(parse_url.pathname);

      }else {
        //document.location.href=url;
        window.open(url, '_blank').focus();
      }

      return false;
    },
    startParseText(){
      var app=this;
      if(app.user.description && app.user.description.length>0 ){
        const elem = app.user.description;

        app.parsed_text=elem.replace(/(https?:\/\/[^\s]+)/g, `<a class='mark' href="$1">$1</a>`)

      }
      app.is_load=true;

    },
  },
  mounted(){

    var app=this;
    app.image_url = Vue.config.IMAGE_URL;

    app.startParseText();

  }
}
</script>

<style scoped>

</style>